/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Tweet } from "react-twitter-widgets";
import styled from "styled-components";

interface Props {
  tweetId: string;
  theme: string;
  disableMouse: boolean;
}

export const TwitterEmbed = ({ tweetId, theme, disableMouse }: Props) => {
  return (
    <TweetWrapper disableMouse={disableMouse}>
      <Tweet options={{ align: "center", theme }} tweetId={tweetId} />
    </TweetWrapper>
  );
};

const TweetWrapper = styled.div<{ disableMouse: boolean }>`
  margin-top: -10px;
  padding: 10px;
  height: 100%;
  width: 100%;
  pointer-events: ${({ disableMouse }) => (disableMouse ? "none" : "auto")};
`;
